import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FreeShippingPopupIcon } from "@/utils/miscIcons.jsx";

const MySwal = withReactContent(Swal);

const title =
  window.post_template.checkout_v4_global_components?.tr_checkout_v4_free_shipping_popup_title || "Right on time!";
const subTitle =
  window.post_template.checkout_v4_global_components?.tr_checkout_v4_free_shipping_popup_text ||
  "Free shipping applied";
const displayTime =
  window.post_template.checkout_v4_global_components?.checkout_v4_free_shipping_popup_display_time * 1000 || 1500;
const checkMarkFill =
  window.post_template.checkout_v4_global_components?.checkout_v4_free_shipping_popup_icon_bg_color || "#77CC00";
const popupBgColor =
  window.post_template.checkout_v4_global_components?.checkout_v4_free_shipping_popup_bg_color || "#FFFFFF";
const titleColor =
  window.post_template.checkout_v4_global_components?.checkout_v4_free_shipping_popup_title_color || "#000000";
const subTitleColor =
  window.post_template.checkout_v4_global_components?.checkout_v4_free_shipping_popup_text_color || "#000000";

document.documentElement.style.setProperty("--free-shipping-popup-title-color", titleColor);
document.documentElement.style.setProperty("--free-shipping-popup-text-color", subTitleColor);

export const useFreeShippingPopup = () => {
  const showPopup = async () => {
    return MySwal.fire({
      iconHtml: <FreeShippingPopupIcon fill={checkMarkFill} />,
      title: title,
      text: subTitle,
      showConfirmButton: false,
      background: popupBgColor,
      timer: displayTime,
      position: "center",
      customClass: {
        container: "free-shipping-popup-container",
        popup: "free-shipping-popup",
        icon: "free-shipping-popup__icon",
        title: "free-shipping-popup__title",
        htmlContainer: "free-shipping-popup__content",
      },
      padding: "40px",
    });
  };

  return { showPopup };
};
